const dayLength = 86400000;

export function deliveryDates(now, config) {
  const parts = Object.fromEntries(new Intl.DateTimeFormat('en-GB', {
    timeZone: config.timeZone || 'Europe/Rome', year: 'numeric', month: '2-digit',
    day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23'
  }).formatToParts(now).map(part => [part.type, part.value]));
  const ordered = Date.UTC(Number(parts.year), Number(parts.month) - 1, Number(parts.day));
  const holidays = new Set(String(config.holidays || '').split(/[\s,;]+/).filter(value => /^\d{4}-\d{2}-\d{2}$/.test(value)));
  const iso = value => new Date(value).toISOString().slice(0, 10);
  const working = value => !holidays.has(iso(value)) && (!config.businessDays || ![0, 6].includes(new Date(value).getUTCDay()));
  const add = (value, days) => {
    for (let remaining = days, limit = 0; remaining > 0 && limit < 3660; limit++) {
      value += dayLength;
      if (working(value)) remaining--;
      if (limit === 3659 && remaining > 0) throw new RangeError('Delivery calendar has no usable dates');
    }
    return value;
  };
  const bounded = value => Math.min(60, Math.max(0, Math.trunc(Number(value) || 0)));
  const preparation = bounded(config.preparation);
  const minimum = Math.max(preparation, bounded(config.minimum));
  const maximum = Math.max(minimum, bounded(config.maximum));
  const cutoff = /^([01]\d|2[0-3]):[0-5]\d$/.test(config.cutoff) ? config.cutoff : '23:59';
  let start = ordered;
  if (`${parts.hour}:${parts.minute}` > cutoff) start = add(start, 1);
  return { ordered: iso(ordered), prepared: iso(add(start, preparation)), minimum: iso(add(start, minimum)), maximum: iso(add(start, maximum)) };
}

if (typeof window !== 'undefined' && !customElements.get('ab-delivery-estimate')) {
  customElements.define('ab-delivery-estimate', class extends HTMLElement {
    connectedCallback() {
      this.renderDates();
      this.refresh = () => this.renderDates();
      document.addEventListener('visibilitychange', this.refresh);
      this.timer = window.setInterval(this.refresh, 60000);
    }

    disconnectedCallback() {
      document.removeEventListener('visibilitychange', this.refresh);
      window.clearInterval(this.timer);
    }

    renderDates() {
      if (document.hidden) return;
      const dates = deliveryDates(new Date(), {
        timeZone: this.dataset.timeZone, preparation: this.dataset.preparation,
        minimum: this.dataset.minimum, maximum: this.dataset.maximum,
        cutoff: this.dataset.cutoff, businessDays: this.dataset.businessDays === 'true',
        holidays: this.dataset.holidays
      });
      const text = value => {
        const [year, month, day] = value.split('-');
        return `${day}/${month}/${year}`;
      };
      for (const [key, value] of Object.entries(dates)) {
        for (const element of this.querySelectorAll(`[data-delivery-date="${key}"]`)) {
          if (element.textContent !== text(value)) element.textContent = text(value);
          element.setAttribute('datetime', value);
        }
      }
      this.querySelector('[data-delivery-relative]')?.setAttribute('hidden', '');
      this.querySelector('[data-delivery-absolute]')?.removeAttribute('hidden');
      this.dataset.ready = 'true';
    }
  });
}
